import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import React, { useContext } from 'react';
import CardContent from './CardContent';
import CardContentEnhanced from './CardContentEnhanced';
import classnames from 'classnames';
import { Context } from '../../store/store';
import { isProductInTradingRange } from '../../../../utilities/product-utilities';
import { useEventListener } from '../../../../hooks/useEventListener';
import { useSelector } from 'react-redux';

const Wrapper = ({ product, index, isFeatured }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const [state, dispatch] = useContext(Context);
	const { loaded } = state;

	useEventListener(`lazy-load-${product.ColourId}`, () => {
		dispatch({ type: 'UPDATE_LOADED', payload: true });
	});

	const tradingRangeInfo = isProductInTradingRange(product.Code);

	const props = {
		id: product.Code,
		className: classnames(
			'relative h-full w-full bg-white p-2 rounded-lg border-gray-30',
			{
				'my-2': !isFeatured,
				'border border-solid': loaded && !isFeatured,
				'pt-8': tradingRangeInfo,
				'wrapper--hover': CustomCategoriesEnabled && !isFeatured,
			}
		),
		['data-productcode']: product.Code,
		['data-testid']: 'product-card-list-view',
		['data-lazy-sku']: product.ColourId,
	};

	const Content = product.ShouldShowEnhancedCard
		? CardContentEnhanced
		: CardContent;

	return React.createElement(
		isFeatured ? 'div' : 'li',
		props,
		<Content {...{ index, product, tradingRangeInfo, isFeatured }} />
	);
};

export default Wrapper;
